import moment from "moment"
import { IDateParams, ISimpleParams, IStateParams, IYearMonthParams } from "types"

moment.locale("es")

export const transformDocumentReportParams = (emails: string[], reportTypes: number[], simpleParams?: ISimpleParams, taxParams?: IYearMonthParams, atsParams?: IYearMonthParams) => {
    const tax = taxParams ? {
        year: taxParams?.yearMonth?.getFullYear()?.toString(),
        month: (taxParams?.yearMonth?.getMonth() + 1)?.toString().padStart(2, '0')
    } : undefined
    const ats = atsParams ? {
        year: atsParams?.yearMonth?.getFullYear()?.toString(),
        month: (atsParams?.yearMonth?.getMonth() + 1)?.toString().padStart(2, '0')
    } : undefined
    const simple = simpleParams ? {
        types: simpleParams?.types,
        conditions: simpleParams?.conditions,
        documentEnd: simpleParams?.documentEnd,
        documentStart: simpleParams?.documentStart
    } : undefined
    const reportParams = {
        emails,
        reportTypes,
        tax,
        simple,
        ats
    }
    return reportParams
}

export const transformALCOReportParams = (emails: string[], reportTypes: number[], almacenerasParams?: IYearMonthParams, consiliacionParams?: IYearMonthParams) => {
    const almaceneras = almacenerasParams ? {
        year: almacenerasParams?.yearMonth?.getFullYear()?.toString(),
        month: (almacenerasParams?.yearMonth?.getMonth() + 1)?.toString().padStart(2, '0')
    } : undefined
    const consiliacion = consiliacionParams ? {
        year: consiliacionParams?.yearMonth?.getFullYear()?.toString(),
        month: (consiliacionParams?.yearMonth?.getMonth() + 1)?.toString().padStart(2, '0')
    } : undefined
    const reportParams = {
        emails,
        reportTypes,
        almaceneras,
        consiliacion
    }
    return reportParams
}

export const transformRejectedReportParams = (emails: string[], states: number[], rejectedStart: Date | null, rejectedEnd: Date | null) => {
    const reportParams = {
        emails,
        states,
        rejectedStart,
        rejectedEnd
    }
    return reportParams
}

export const transformRetentionReportParams = (user: string, reportTypes: number[], mailsToSend: string[], stateParams?: IStateParams, retentionParams?: IDateParams, accountingParams?: IDateParams, reclaimParams?: IDateParams) => {
    const currentInquiryDate = moment(new Date())?.format('yyyy-MM-DD hh:mm:ss')?.toString()
    const currentUserRequest = user
    const state = stateParams ? {
        reportType: 1,
        conditions: stateParams?.conditions,
        initialDate: moment(stateParams?.documentStart)?.format('yyyy-MM-DD')?.toString(),
        endDate: moment(stateParams?.documentEnd)?.format('yyyy-MM-DD')?.toString(),
    } : undefined
    const retention = retentionParams ? {
        reportType: 2,
        conditions: null,
        initialDate: moment(retentionParams?.documentStart)?.format('yyyy-MM-DD')?.toString(),
        endDate: moment(retentionParams?.documentEnd)?.format('yyyy-MM-DD')?.toString(),
    } : undefined
    const accounting = accountingParams ? {
        reportType: 3,
        conditions: null,
        initialDate: moment(accountingParams?.documentStart)?.format('yyyy-MM-DD')?.toString(),
        endDate: moment(accountingParams?.documentEnd)?.format('yyyy-MM-DD')?.toString(),
    } : undefined
    const reclaim = reclaimParams ? {
        reportType: 4,
        conditions: null,
        initialDate: moment(reclaimParams?.documentStart)?.format('yyyy-MM-DD')?.toString(),
        endDate: moment(reclaimParams?.documentEnd)?.format('yyyy-MM-DD')?.toString(),
    } : undefined
    const reports : any[] = []
    if (reportTypes.includes(1)) { reports.push(state) }
    if (reportTypes.includes(2)) { reports.push(retention) }
    if (reportTypes.includes(3)) { reports.push(accounting) }
    if (reportTypes.includes(4)) { reports.push(reclaim) }
    const reportParams = {
        currentInquiryDate,
        currentUserRequest,
        mailsToSend,
        reports
    }
    return reportParams
}